// extracted by mini-css-extract-plugin
module.exports = {"productFlag":"new-flag_productFlag__tIlWO","new":"new-flag_new__h3duJ","flagImage":"new-flag_flagImage__zO4nm"};